var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDevelopment = function SvgDevelopment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.99 4.466a.782.782 0 0 0-.783-.782C17.072 3.684 13.516 6.21 12 9.8c-1.516-3.59-5.072-6.116-9.208-6.116a.782.782 0 0 0-.782.782c0 5.245 4.064 9.56 9.208 9.96v5.108a.782.782 0 0 0 1.563 0v-5.109c5.145-.4 9.209-4.714 9.209-9.959Zm-18.377.821a8.441 8.441 0 0 1 7.566 7.566 8.442 8.442 0 0 1-7.566-7.566Zm9.208 7.566a8.441 8.441 0 0 1 7.566-7.566 8.443 8.443 0 0 1-7.566 7.566Z"
  })));
};

export default SvgDevelopment;